const defaultState = {
  errors: {},
  ui: {
    success: false,
    loading: false,
  },
};

export default defaultState;
